import { Badge } from 'antd';
import React, { useContext, useEffect, useState,useRef } from 'react'
import { useLocation } from 'react-router';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/TgMultiSelectEntity'
import FilterWrapper from './FilterWrapper';
import { filterInvestor, FilterReInvestor, FilterIncubator } from "../../Config/config"
import useScrollIntoView from './useScrollIntoView';

function Investor({ open, accordionClick, options, setOptions, customPathname, label, menu }) {

    const [companyVal, setCompanyVal] = useState("");
    const [fetchedData, setFetchedData] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const inputRef = useRef(null);
    const dropdownRef = useRef(null);
    const shouldScroll = open || fetchedData.length > 0;
    const listItemRef = useScrollIntoView(shouldScroll);
    const { accessControl, refineSearchFilters, SwitchState, setSwitchState } = useContext(PeFilterContext);
    const location = useLocation();

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (companyVal.trim() !== "") {
                fetchData();
            } else {
                // Don't clear options on empty search - keep selected items
                setShowDropdown(false);
            }
        }, 300);

        return () => clearTimeout(delayDebounceFn);
    }, [companyVal]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target) && 
                inputRef.current && !inputRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Auto-scroll when dropdown opens and goes below visible screen
    useEffect(() => {
        if (showDropdown && dropdownRef.current && inputRef.current) {
            setTimeout(() => {
                const dropdownRect = dropdownRef.current.getBoundingClientRect();
                const viewportHeight = window.innerHeight;
                
                // Check if dropdown bottom goes below viewport
                if (dropdownRect.bottom > viewportHeight - 20) {
                    inputRef.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'nearest'
                    });
                }
            }, 150); // Small delay to ensure dropdown is rendered
        }
    }, [showDropdown, fetchedData]);

    
    let categoryVal;

    // Check for exits first (more specific)
    if (location.pathname?.includes("/exits") || location.pathname?.includes("/exit") || location.pathname?.includes("ma-exits")) {
        categoryVal = "exits";
    } 
    // Check for backed IPOs
    else if (location.pathname?.includes("backed-ipos") || location.pathname?.includes("backed-ipo")) {
        categoryVal = "ipo";
    } 
    // Check for angel investments
    else if (location.pathname?.includes("angel-invesments") || location.pathname?.includes("angel")) {
        categoryVal = "angel";
    }
    // Check for incubation
    else if (location.pathname?.includes("incubation")) {
        categoryVal = "incubation";
    }
    // Default to investments for all paths containing investor filter
    // This includes: investors/, companies/, advisors/, transaction-advisors/, etc.
    else if (
        location.pathname?.includes("investors/") || 
        location.pathname?.includes("companies/") || 
        location.pathname?.includes("company/") ||
        location.pathname?.includes("advisors/") || 
        location.pathname?.includes("transaction-advisor") ||
        location.pathname?.includes("/pe/") ||
        location.pathname?.includes("/vc/")
    ) {
        categoryVal = "investments";
    }
    
    const filter = customPathname?.includes("/re/") ? FilterReInvestor : customPathname?.includes("/incubation") ? FilterIncubator : filterInvestor;

    // console.log(customPathname, "category:", categoryVal, "menu:", menu);

const fetchData = () => {
    const payload = { 
        search_key: companyVal,
        category: customPathname?.includes("pe-vc-limited-partners")
            ? "limited_partners"
            : customPathname?.includes("/re/")
            ? menu
            : categoryVal
    };
    

    if(filter === filterInvestor){
        
        payload.industry_ids = accessControl?.peindustries?.id?.length > 0 ? accessControl?.peindustries?.id : [];
        payload.tag_ids = accessControl?.pe_tags?.id?.length > 0 ? accessControl.pe_tags.name : [];
        payload.stage_ids =  accessControl?.pe_stage?.id?.length > 0 ? accessControl.pe_stage : [];
        payload.deal_range_usd_min = accessControl?.pe_deal_range?.from;
        payload.deal_range_usd_max =  accessControl?.pe_deal_range?.to;
        payload.country_ids = accessControl?.pe_countries?.id?.length ? accessControl?.pe_countries?.id : [];
        payload.region_ids =  accessControl?.pe_regions?.id?.length ? accessControl?.pe_regions?.id : [];
        payload.states_ids =  accessControl?.pe_states?.id?.length ? accessControl?.pe_states?.id : [];
        payload.city_ids =  accessControl?.pe_cities?.id?.length ? accessControl?.pe_cities?.id : [];

    } else if (filter === FilterIncubator){

        payload.industry_ids = accessControl?.peindustries?.id?.length > 0 ? accessControl?.peindustries?.id : [];
        payload.tag_ids = accessControl?.pe_tags?.id?.length > 0 ? accessControl.pe_tags.name : [];
        payload.country_ids = accessControl?.pe_countries?.id?.length ? accessControl?.pe_countries?.id : [];
        payload.region_ids =  accessControl?.pe_regions?.id?.length ? accessControl?.pe_regions?.id : [];
        payload.states_ids =  accessControl?.pe_states?.id?.length ? accessControl?.pe_states?.id : [];
        payload.city_ids =  accessControl?.pe_cities?.id?.length ? accessControl?.pe_cities?.id : [];
    
    }
    
    fetch(filter, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
            body: JSON.stringify(payload)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                if (data?.results) {
                    const modifiedData = data.results.map(item => ({
                        ...item,
                        isChecked: false
                    }));
                    setFetchedData(data?.results); 
                    setShowDropdown(true);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setFetchedData([]);
                setShowDropdown(false);
            });
    }

    useEffect(() => {
        if (!fetchedData || !Array.isArray(fetchedData)) return;

        if (categoryVal === "angel" || filter === FilterIncubator) {
           const uniqueFetchedData = fetchedData;
                setOptions(prevOptions => [...prevOptions.filter(item => item.isChecked === true), ...uniqueFetchedData]);
        } else {
            // For other categories, mark isChecked based on investor match
            setOptions(prev => {
                const filterItems = refineSearchFilters?.[customPathname]?.investor_id || [];

                // Create map to store final options (id -> item)
                const itemMap = new Map();

                // 1. Add fetched data (default isChecked false)
                fetchedData.forEach(item => {
                    itemMap.set(item.id, { ...item, isChecked: false });
                });

                // 2. Add previously selected items (prev) — only if still checked
                (prev || []).forEach(item => {
                    if (item.isChecked) {
                        itemMap.set(item.id, item);
                    }
                });

                // 3. Apply current filters — set isChecked as per latest filters
                filterItems.forEach(item => {
                    itemMap.set(item.id, { ...item, isChecked: true });
                });

                return Array.from(itemMap.values());
            });
        }
    }, [fetchedData, customPathname, refineSearchFilters, categoryVal]);
    

    const handleIndustryChange = ((e) => {
        const { name, checked, id } = e.target;
        let currentIndustry = [];

        if (name === "allSelect") {
            currentIndustry = options.map((industry) =>
                ({ ...industry, isChecked: checked })
            );
            setOptions(currentIndustry);
        } else {
            currentIndustry = options.map((industry) =>
                industry.id === parseInt(id) ? { ...industry, isChecked: checked } : industry
            );
            setOptions(currentIndustry);
        }
    });




    const selectedIndustryLength = options?.filter(option => option.isChecked)?.length ?? 0;
    const hasValue = companyVal || selectedIndustryLength > 0;
    
    return (
        <div className="relative">
            <div className={`absolute left-3 md:left-5 transition-all duration-200 pointer-events-none flex items-center gap-1 md:gap-2 z-10 ${
                isFocused || hasValue 
                    ? 'top-0 -translate-y-1/2 text-xs bg-white px-1 text-[#BC8B20]' 
                    : 'top-1/2 -translate-y-1/2 text-xs md:text-sm text-gray-500'
            }`}>
                <span>{label}</span>
                {!isFocused && !hasValue && (
                    <span className="opacity-60 ml-1 md:ml-2 text-[10px] md:text-xs hidden sm:inline-block max-w-[150px] truncate">e.g. Peak XV Partners, Accel India</span>
                )}
                {(isFocused || hasValue) && selectedIndustryLength > 0 && (
                    <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                        {selectedIndustryLength}
                    </span>
                )}
            </div>
            
            <div className="relative border border-gray-300 rounded-md bg-white">
                <div className="flex items-center">
                    <input
                        ref={inputRef}
                        type="text"
                        value={companyVal}
                        onChange={(e) => setCompanyVal(e.target.value)}
                        onFocus={() => {
                            setIsFocused(true);
                            // Show dropdown if there are fetched results OR if there are selected options
                            const hasSelectedOptions = options.some(option => option.isChecked);
                            if (fetchedData.length > 0 || hasSelectedOptions) {
                                setShowDropdown(true);
                            }
                        }}
                        onBlur={() => {
                            setTimeout(() => setIsFocused(false), 200);
                        }}
                        className="w-full px-4 py-2 rounded-lg focus:outline-none bg-transparent"
                        placeholder=""
                    />
                    
                    
                    {/* AND/OR Toggle inside input box */}
                    <div className="pr-2 flex-shrink-0">
                        <div className="flex items-center space-x-[6px] rounded py-[2px] px-[5px] bg-white p-1 shadow-card">
                            <span
                                onClick={() => setSwitchState("and")}
                                className={`flex items-center space-x-[6px] rounded py-[2px] px-[5px] text-[11px] cursor-pointer ${
                                    SwitchState === "and" 
                                        ? 'text-[#FFFFFF] bg-[#BC8B20]' 
                                        : 'text-body-color'
                                }`}>
                                AND
                            </span>
                            <span
                                onClick={() => setSwitchState("or")}
                                className={`flex items-center space-x-[6px] rounded py-[2px] px-[5px] text-[11px] cursor-pointer ${
                                    SwitchState === "or" 
                                        ? 'text-[#FFFFFF] bg-[#BC8B20]' 
                                        : 'text-body-color'
                                }`}>
                                OR
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Search Results Dropdown - Positioned BELOW the input */}
            {showDropdown && (fetchedData.length > 0 || options.some(option => option.isChecked)) && (
                <div ref={dropdownRef} className="px-2 absolute z-50 w-full top-full mt-1 bg-white border border-gray-100 rounded-sm shadow-lg max-h-64 overflow-y-auto">
                    <MultiSelectEntity
                        fetchData={fetchData}
                        handleEntityChange={handleIndustryChange}
                        primaryEntity={options}
                        setCompanyVal={setCompanyVal}
                        city="city"
                    />
                </div>
            )}
        </div>
    )
}

export default Investor;